import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'

/** @param {import('@ark-ui/react/date-picker').DatePickerTriggerProps} props */
export const DatePickerTrigger = ({children}) => {
	return <ArkDatePicker.Trigger asChild>{children}</ArkDatePicker.Trigger>
}
